import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('micoach-theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('micoach-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  return (
  <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
    {children}
  </ThemeContext.Provider>
);
}

export const useTheme = () => useContext(ThemeContext);
